import { Fv, About, Problem, Point, Service, Contact, News, Banner } from "../components/Project";
import { Grid, Space } from "../components/Layout";
import { Media, ScrollTop } from "../components/Object";

const Home = () => {

  return (
    <>
      <Fv />

      <About />
    
      <Problem />

      <Point />

      <Service />

      <Contact />

      <News />

      <Banner />
    </>
  );
};

export default Home;
